import { render, staticRenderFns } from "./OnlCgformHeadList.vue?vue&type=template&id=1459f481&scoped=true&"
import script from "./OnlCgformHeadList.vue?vue&type=script&lang=js&"
export * from "./OnlCgformHeadList.vue?vue&type=script&lang=js&"
import style0 from "./OnlCgformHeadList.vue?vue&type=style&index=0&id=1459f481&prod&scoped=true&lang=css&"
import style1 from "./OnlCgformHeadList.vue?vue&type=style&index=1&id=1459f481&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1459f481",
  null
  
)

export default component.exports